// Changelog entry images
import deploymentFlow from '@/images/changelog/deployment-flow.webp';
import navigationPanel from '@/images/changelog/navigation-panel.webp';
import devopsTab from '@/images/changelog/devops-tab.webp';
import updatedNavigation from '@/images/changelog/updated-navigation.webp';
import filterScreen1 from '@/images/changelog/filter-screen-1.webp';
import filterScreen2 from '@/images/changelog/filter-screen-2.webp';
import timestamps from '@/images/changelog/timestamps.webp';

export const changelogImages = {
  '2025-06-dependency-management': {
    image: null, // No hero image for this entry
  },
  '2025-05-deployment-navigation': {
    image: deploymentFlow,
  },
  '2025-04-version-statuses-devops': {
    image: devopsTab,
  },
  '2025-02-updated-navigation': {
    image: updatedNavigation,
  },
  '2025-01-timestamps-filters': {
    image: filterScreen1,
  },
};